import React from "react";
import { motion } from "framer-motion";

/** Shared brand header for standalone OrangeBySite customer-facing pages
 *  (Optimise checkout, PayPal return, subscription success/cancel, secure
 *  reports, etc). Uses the existing official logo asset — never a
 *  recreated / redrawn / substituted mark. Slim; does NOT duplicate the
 *  main-site navigation.
 */
export default function OrangeBySiteStandaloneHeader({ subtitle, dark = false }) {
  return (
    <motion.header
      data-testid="obs-standalone-header"
      initial={{ y: -8, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
      className="w-full"
    >
      <div className="max-w-6xl mx-auto px-5 sm:px-8 pt-6 pb-2 flex items-center justify-between gap-4">
        <a
          href="/"
          data-testid="obs-standalone-header-logo"
          className="inline-flex items-center leading-none shrink-0"
          aria-label="OrangeBySite home"
        >
          <img
            src="/orangebysite-logo-white-black-v2.webp"
            alt="ORANGEBYSITE"
            className="h-11 md:h-14 w-auto select-none object-contain block"
            style={{
              // The asset is a two-tone raster (white "Orange" + black "BYSITE").
              // On light backgrounds force the whole mark to pure black so the
              // entire ORANGEBYSITE wordmark is visible; on dark backgrounds
              // force it to pure white. Same technique HQBrand uses across HQ.
              filter: dark
                ? "brightness(0) invert(1)"
                : "brightness(0)",
            }}
            draggable={false}
          />
        </a>

        {subtitle && (
          <div
            className={`hidden sm:block text-[10px] tracking-[0.28em] uppercase font-bold ${
              dark ? "text-white/85" : "text-black/70"
            }`}
            data-testid="obs-standalone-header-subtitle"
          >
            {subtitle}
          </div>
        )}

        <a
          href="/"
          data-testid="obs-standalone-header-back"
          className={`text-[11px] tracking-[0.22em] uppercase font-bold hover:opacity-70 transition-opacity ${
            dark ? "text-white" : "text-black"
          }`}
        >
          ← Back to OrangeBySite
        </a>
      </div>
    </motion.header>
  );
}
